import { useState } from "react";

interface UseCurrencyInputOptions<T extends number | null> {
  value: T;
  format: (value: T) => string;
  parse: (raw: string) => T;
  rawEdit: (value: T) => string;
  onChange: (value: T) => void;
}

export function useCurrencyInput<T extends number | null>({
  value,
  format,
  parse,
  rawEdit,
  onChange,
}: UseCurrencyInputOptions<T>) {
  const [inputValue, setInputValue] = useState(() => format(value));
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
    setInputValue(rawEdit(value));
  };

  const handleBlur = () => {
    setIsFocused(false);
    const parsed = parse(inputValue);
    onChange(parsed);
    setInputValue(format(parsed));
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  return {
    displayValue: isFocused ? inputValue : format(value),
    handleFocus,
    handleBlur,
    handleChange,
  };
}
